module.exports = __webpack_public_path__ + "prev.png?4f066b9dc50b868865039f826139390f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/prev.png
// module id = 62
// module chunks = 0